import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Observable }        from 'rxjs/Observable';
import { Subject }           from 'rxjs/Subject';
import { isBrowser } from 'angular2-universal';
// Observable class extensions
import 'rxjs/add/observable/of';
// Observable operators
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { SearchService } from './search.service';
import { MapToIterable } from './map-to-iterable.pipe';
import { ReplacePipe } from './replace.pipe';
import { UtilsService } from './utils.service';
import { ElasticSearchService } from './search-elasticsearch.service';

declare var $: any;

@Component({
    selector: 'search',
    template: require('./partials/search.html'),
    styles: [require('./assets/css/search.css')]
})
export class SearchComponent implements OnInit {

    @Input() type: string = 'local'; // local | glogal
    @Input() order: string[];
    @Input() scrollOnClick: string;
    @Input() target: string;
    @Input() placeholder: string;
    @Input() language: string;
    @Input() labels: any;
    @Input() expand: boolean = false;
    // @Output() onSearch: EventEmitter<Object> = new EventEmitter<Object>();
    suggestionTriggerThreshold = 2;
    formQuery: string;
    keepSuggestions = false;

    private suggestionEventEmitter = new Subject<string>();
    public suggestions: Object;
    private filterQueryParams: string;
    private searchQueryParams: string;

    constructor(private utils: UtilsService, private search: SearchService, private es: ElasticSearchService, private route: ActivatedRoute, private router: Router) {}

    ngOnInit() {
        // Suggestion stream management
        this.suggestionEventEmitter
                .debounceTime(300)
                //.distinctUntilChanged()
                .switchMap(term => {
                    return this.search.suggest('record',term);
                    //return this.es.suggest(term);
                }).subscribe(res => {
                    this.suggestions = this.es.formatSuggestions(res.suggest);
                }, error => {
                    console.log(error);
                });
        // Clear box when search removed by user
        this.route.queryParams.subscribe(params => {
            this.searchQueryParams = params['s'];
            this.filterQueryParams = params['f'];
            // if(this.es.clearSearchBox){
            //     this.formQuery = "";
            //     this.es.clearSearchBox = false;
            // }
        });
    }

    onInputClick(input: string, event:any) {
        if (isBrowser && this.scrollOnClick!=null) {
            $('html, body').animate({
                scrollTop: this.utils.getElementPosition(this.scrollOnClick, 20, -20)
            }, 1000);
        }
    }

    onInputChange(input: string, event:any) {
        if(event.key=='Enter')
            this.suggestions = null;
        else if(input.length >= this.suggestionTriggerThreshold)
            this.suggestionEventEmitter.next(input);
        else 
            this.suggestions = null;
    }

    onSuggestSelect(type: string, value: string){
        // Nav
        let newQueryParams = { queryParams: {} };
        //newQueryParams.queryParams['f'] = this.utils.appendQueryParam(this.filterQueryParams, type, value);
        newQueryParams.queryParams['f'] = this.utils.appendQueryParam('', type, value);
        //newQueryParams['relativeTo'] = this.route.parent;
        // this.router.navigate([this.target], newQueryParams);
        this.utils.lNavigate(this.target, this.language, this.route.parent, newQueryParams); 
        // Clear
        this.formQuery = "";
        this.suggestions = null;
    }

    onSearchLeave(){
        this.keepSuggestions = false;
        setTimeout(()=>{ 
            // In the mean time, move may have come back over
            if(!this.keepSuggestions)
                this.suggestions = null 
        }, 1500)
    }
    onSearchOver(){
        this.keepSuggestions = true;
    }

    onSubmit(){
        // Callback 
        //this.onSearch.emit(this.formQuery);
        // Nav
        if(this.formQuery!="" && this.formQuery!=null)
            this.utils.lNavigate(this.target, this.language, this.route.parent, { queryParams: { s: this.formQuery } });
        else 
            this.utils.lNavigate(this.target, this.language, this.route.parent);
        // Clear suggestions
        this.suggestions = null;
    }

    // target format: {type1: [{name: name1, freq: 2}]} 
    // formatSuggestions(){
    //     // Compute freq
    //     let formated = {};
    //     for(let type in this.suggestions){
    //         formated[type] = {};
    //         for(let s of this.suggestions[type][0].options){
    //             if(!formated[type][s.text])
    //                 formated[type][s.text] = 1;
    //             else 
    //                 formated[type][s.text] = formated[type][s.text] + 1;
    //         }
    //     }
    //     // Format in an ordered array of objects
    //     let sorted:any = {};
    //     for(let type in formated){
    //         sorted[type] = [];
    //         for(let e in formated[type]){
    //             sorted[type].push({name: e, freq: formated[type][e]});
    //         }
    //         sorted[type].sort(function(obj1:any, obj2:any) {
    //             return obj2.freq - obj1.freq;
    //         });
    //     }
    //     this.suggestions = sorted;
    // }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/search.component.ts